// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface ImageManagementEndpointsProps {
  get_image_resource: (encrypted: string) => string;
  get_image_download: () => string;
  get_image_preview_download: () => string;
}

// 이미지 관리 관련 엔드포인트 정의
export const ImageManagementEndpoints: ImageManagementEndpointsProps = {
  get_image_resource: (encrypted) => `api/images/${encrypted}`, // 이미지 리소스 조회
  get_image_download: () => `api/images/download`, // 이미지 다운로드
  get_image_preview_download: () => `api/images/download/preview`, // 이미지 미리보기 + 다운로드
};

export default ImageManagementEndpoints;
